<template>
    <header class="py-2 px-4 navbar flex flex-wrap items-center justify-between relative navbar-header bg-green-600 navbar-header-fixed sm:fixed sm:top-0 sm:left-0 sm:right-0 z-20">
        <div v-on-clickaway="hide" class="container-fluid flex flex-wrap items-center justify-between px-4 lg:px-10">
            <a v-touch:tap="show" @click.prevent.stop="show" href="javascript:void(0)" class="burger-menu flex items-center mr-4 text-white lg:hidden">
                <i class="far fa-bars"></i>
            </a>

            <div class="navbar-brand flex items-center order-1 py-1 mr-4 text-xl whitespace-no-wrap" class2="inline-block">
                <a :href="route('home')" class="brand-logo">
                    <img :data-src="url('img/icon_trans.png')" :alt="appName" class="lazyload img-white inline sm:hidden mx-2" style="height:30px;" />
                    <!-- <img :data-src="url('img/logo.png')" alt="appName" class="lazyload img-white inline sm:hidden" style="height:15px;" /> -->
                    <img :data-src="url('img/icon_trans.png')" :alt="appName" class="lazyload img-white hidden sm:inline mr-4" style="height:30px;" />
                    <img :data-src="url('img/logo.png')" :alt="appName" class="lazyload img-white hidden sm:inline" style="height:20px;" />
                </a>
            </div>

            <div :class="{'translate-x-0': open, '-translate-x-full': !open}" class="order-3 w-64 fixed top-0 bottom-0 left-0 bg-white overflow-hidden transform lg:transform-none transition-all duration-200 lg:w-auto lg:py-0 lg:px-6 lg:relative lg:top-auto lg:left-auto lg:bottom-auto lg:bg-transparent lg:overflow-visible lg:flex lg:flex-1 lg:justify-center lg:order-2 lg:z-auto xl:py-0 xl:px-8 z-20">
                <div class="navbar-menu-header flex items-center justify-between border-b">
                    <a :href="route('home')" class="brand-logo">
                        <img :data-src="url('img/logo.png')" :alt="appName" class="lazyload" style="height:20px;" />
                    </a>
                    <a v-touch:tap="hide" @click.prevent.stop="hide" href="javascript:void(0)">
                        <i class="far fa-times"></i>
                    </a>
                </div>

                <ul class="nav navbar-menu">
                    <li class="nav-label pl-5 lg:hidden">
                        {{ __('Navigation') }}
                    </li>
                    <!-- <li :class="{ 'active': route().current('learn') }" class="nav-item">
                        <a href="{{ route('learn') }}" class="nav-link text-black lg:text-white">
                            {{ __('How It Works') }}
                        </a>
                    </li> -->
                    <nav-menu :active="route().current('products')" type="li" :class="{ 'active': route().current('products') }" class="nav-item with-sub">
                        <template slot="link">
                            {{ __('Products') }}
                        </template>
                        <template slot="items">
                            <!-- <li class="nav-sub-item">
                                <a :href="route('products')+'?stocked=1'" class="nav-sub-link">{{ __('In Stock') }}</a>
                            </li> -->
                            <!-- <li class="nav-sub-item">
                                <a :href="route('products')+'?stocked=0'" class="nav-sub-link">{{ __('Sold Out') }}</a>
                            </li> -->
                            <li class="nav-sub-item">
                                <a :href="route('products')" class="nav-sub-link">{{ __('View All Products') }}</a>
                            </li>
                            <li :class="{ 'active': route().current('products.request') }" class="nav-sub-item">
                                <a :href="route('products.request')" class="nav-sub-link">{{ __('New Request') }}</a>
                            </li>
                        </template>
                    </nav-menu>
                    <li :class="{ 'active': route().current('categories') }" class="nav-item">
                        <a :href="route('categories')" class="nav-link text-black lg:text-white">
                            {{ __('Categories') }}
                        </a>
                    </li>
                    <li :class="{ 'active': route().current('stores') }" class="nav-item">
                        <a :href="route('stores')" class="nav-link text-black lg:text-white">
                            {{ __('Stores') }}
                        </a>
                    </li>
                    <!-- <li :class="{ 'active': route().current('local') }" class="nav-item">
                        <a href="{{ route('local') }}" class="nav-link text-black lg:text-white">
                            {{ __('Local') }}
                        </a>
                    </li> -->
                    <!-- <li :class="{ 'active': route().current('brands') }" class="nav-item">
                        <a href="{{ route('brands') }}" class="nav-link text-black lg:text-white">
                            {{ __('Brands') }}
                        </a>
                    </li> -->
                    <!-- <li :class="{ 'active': route().current('deals') }" class="nav-item">
                        <a href="{{ route('deals') }}" class="nav-link text-black lg:text-white">
                            {{ __('Deals') }}
                        </a>
                    </li> -->
                    <li :class="{ 'active': route().current('help') }" class="nav-item">
                        <a :href="route('help')" class="nav-link text-black lg:text-white">
                            {{ __('Help/FAQ') }}
                        </a>
                    </li>
                    <nav-menu type="li" class="nav-item with-sub">
                        <template slot="link">
                            {{ __('Community') }}
                        </template>
                        <!-- <div class="lg:flex"> -->
                        <template slot="items">
                            <li class="nav-sub-item">
                                <a :href="route('stories')" class="nav-sub-link">
                                    {{ __('Success Stories') }}
                                </a>
                            </li>
                            <li class="nav-sub-item">
                                <a :href="route('discord.invite')" class="nav-sub-link" target="_blank">
                                    {{ __('Discord Chat') }}
                                </a>
                            </li>
                        </template>
                    </nav-menu>
                    <template v-if="guest">
                        <li class="nav-item">
                            <search-overlay link-class="nav-link text-black lg:text-white font-semibold">
                                <i class="far fa-search hidden lg:block lg:mr-2"></i>
                                {{ __('Search') }}
                            </search-overlay>
                        </li>
                        <li :class="{ 'active': route().current('login') }" class="sm:hidden nav-item">
                            <a :href="route('login')" class="nav-link text-black lg:text-white font-semibold">
                                {{ __('Login') }}
                            </a>
                        </li>
                        <li :class="{ 'active': route().current('register') }" class="sm:hidden nav-item">
                            <a :href="route('register')" class="nav-link text-black lg:text-white">
                                {{ __('Signup') }}
                            </a>
                        </li>
                    </template>
                </ul>
            </div>

            <div class="navbar-right">
                <!-- <nav-search :query="query" /> -->

                <template v-if="guest">
                    <ul class="nav navbar-menu2">
                        <li class="nav-item">
                            <a :href="route('login')" class="nav-link text-white font-semibold">
                                {{ __('Login') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a :href="route('register')" class="btn flex items-center bg-white border-0 text-green-800 font-bold py-2 px-3 sm:py-2 sm:px-4">
                                <span>{{ __('Signup') }}</span>
                            </a>
                        </li>
                    </ul>
                </template>
                <template v-else>
                    <ul class="nav navbar-menu3">
                        <li class="nav-item">
                            <search-overlay link-class="search-link text-white mr-2 lg:mr-3">
                                <i class="far fa-search"></i>
                            </search-overlay>
                        </li>
                        <!-- <li>
                            <i class="far fa-bell"></i>
                            notifications browser
                        </li> -->
                    </ul>

                    <div class="ml-2 sm:ml-4 dropdown dropdown-profile">
                        <nav-dropdown dir="right" menu-class="-mr-2 text-sm">
                            <template slot="link">
                                <div class="avatar avatar-sm w-6 h-6 mr-1">
                                    <img :data-src="user.avatar_url" :alt="user.name" class="lazyload rounded-circle" />
                                </div>
                                <!-- <span class="hidden sm:inline">{{ user.name }}</span> -->
                                <i class="fas fa-chevron-down"></i>
                            </template>

                            <h6 class="font-semibold mb-1">
                                {{ user.name }}
                            </h6>

                            <p class="mb-5 text-sm text-gray-600">
                                {{ user.title }}
                            </p>

                            <!-- <a href="javascript:void(0)" class="dropdown-item">
                                <i class="far fa-user"></i>
                                {{ __('View Profile') }}
                            </a> -->
                            <!-- <div class="dropdown-divider"></div> -->
                            <a v-if="isAdminUser" :href="url('admin')" class="dropdown-item">
                                <i class="far fa-chess-king-alt"></i>
                                {{ __('Admin Panel') }}
                            </a>
                            <a :href="route('alerts')" class="dropdown-item">
                                <i class="far fa-bell"></i>
                                {{ __('My Alerts') }}
                            </a>
                            <a :href="route('settings')" class="dropdown-item">
                                <i class="far fa-cog"></i>
                                {{ __('Settings') }}
                            </a>
                            <a :href="url('logout')" class="dropdown-item" class2="g_id_signout">
                                <i class="far fa-sign-out"></i>
                                {{ __('Logout') }}
                            </a>
                        </nav-dropdown>
                    </div>
                </template>
            </div>
        </div>
    </header>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import UrlMixin from '../../mixins/url';

export default {
    mixins: [
        clickaway,
        UrlMixin
    ],

    props: ['query'],

    data: () => ({
        open: false,
        backdrop: null
    }),

    created() {
        this.createBg();
    },

    destroyed() {
        this.destroyBg();
    },

    mounted() {},

    computed: {},

    methods: {
        show($event) {
            document.querySelectorAll('.dropdown-menu.show').forEach(e => e.classList.remove('show'));

            if (this.mobile) {
                document.body.classList.add('overflow-hidden');
            }

            this.backdrop.classList.add('show');

            this.open = true;

            // this.$emit('nav-opened');
        },

        hide($event) {
            if (this.mobile) {
                document.body.classList.remove('overflow-hidden');
            }

            this.backdrop.classList.remove('show');

            this.open = false;

            // this.$emit('nav-closed');
        },

        createBg() {
            const backdrop = document.createElement('div');
            backdrop.classList = 'backdrop invisible opacity-0 fixed top-0 left-0 w-screen h-screen z-10 transition-all duration-500';
            backdrop.style.cssText = 'background-color: rgba(15,21,32,.7);';

            this.backdrop = backdrop;

            document.body.appendChild(this.backdrop);
        },

        destroyBg() {
            document.body.removeChild(this.backdrop);
        }
    }
}
</script>

<style lang="scss">
// <style lang="postcss">
</style>
